/**
 * Shared bits for config-driven landing templates.
 *
 * A landing variant row (landing_variants.config, created via the ops MCP)
 * may set `template` to pick a layout other than the classic LandingDynamic.
 * Each template component takes the full variant config as its only prop and
 * treats it as fully-resolved content (plain strings, no i18n keys) — MCP
 * variants are authored per-language. See docs/landing-templates.md.
 */

export function quizHref(audienceParam: string, eventTypeParam?: string): string {
  const { hostname } = window.location;
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
  const base = isLocal ? "/app/quiz" : "https://app.outclose.com/quiz";
  const et = eventTypeParam ? `&et=${eventTypeParam}` : "";
  return `${base}?a=${audienceParam}${et}`;
}

/** Sticky bottom CTA used by several templates. */
export function StickyCta({ href, label }: { href: string; label: string }) {
  return (
    <div className="fixed bottom-0 inset-x-0 md:hidden z-50 bg-gradient-to-t from-neutral-200 dark:from-neutral-900 via-neutral-200/95 dark:via-neutral-900/95 to-transparent pt-6 pb-4 px-4">
      <a
        href={href}
        className="rounded-full bg-primary-500 hover:bg-primary-600 text-white font-bold text-base py-3 w-full inline-flex items-center justify-center transition-colors shadow-lg"
      >
        {label}
      </a>
    </div>
  );
}
